import { LoadingDots } from "@repo/ui";
const AddressDropdownMenu = ({
  onEdit,
  onDelete,
  isPending,
  dropdownRef,
  t,
}) => {
  return (
    <div
      ref={dropdownRef}
      className="absolute end-2 top-7 z-50 w-20 rounded-md bg-white shadow-lg ring-1 ring-black/5"
    >
      <button
        onClick={onEdit}
        className="w-full px-3 pb-1 pt-2 text-start text-sm hover:underline"
      >
        {t("Edit")}
      </button>
      <button
        className="w-full px-3 pb-2 pt-1 text-start text-sm hover:underline"
        onClick={onDelete}
      >
        {isPending ? <LoadingDots className="bg-black" /> : t("Delete")}
      </button>
    </div>
  );
};

export default AddressDropdownMenu;
